import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ButtonComponent } from "../../../../../../shared/button/button.component";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../../../../../../shared/shared.module";
import { BaseComponent } from "../../../../../../shared/base-component";
import { InputSelectComponent } from "../../../../../../shared/input-select/input-select.component";
import { DiaryFormElement } from "../../../../../../core/models/trial-diary-form/diary-form-element.model";
import { SelectOption } from "../../../../../../core/models/select-option.model";
import {
  TrialNotificationExpression
} from "../../../../../../core/models/trial-notification-template/trial-notification-template.model";

@Component({
  selector: 'app-trial-notification-condition',
  standalone: true,
    imports: [
        ButtonComponent,
        ReactiveFormsModule,
        SharedModule
    ],
  templateUrl: './trial-notification-condition.component.html',
  styleUrl: './trial-notification-condition.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class TrialNotificationConditionComponent extends BaseComponent implements AfterViewInit {
  @ViewChild('elementIdSelect') elementIdSelect: InputSelectComponent;
  @ViewChild('valueSelect') valueSelect: InputSelectComponent;

  @Output() remove = new EventEmitter();
  @Output() changed = new EventEmitter<TrialNotificationExpression>();

  @Input() index: number = 0;
  @Input() expression: TrialNotificationExpression = new TrialNotificationExpression();
  @Input() elements: DiaryFormElement[] = [];
  @Input() elementOptions: SelectOption[] = [];
  @Input() logicalOperator: string = '';

  protected form = new FormGroup({
    operator: new FormControl<string>('EQUALS'),
    value: new FormControl<string>(null),
    elementId: new FormControl<string>(null)
  });
  protected operatorOptions: SelectOption[] = [
    new SelectOption('EQUALS', 'Equals')];
  protected valueOptions: SelectOption[] = [];

  ngAfterViewInit(): void {
    if (this.expression && this.expression.elementId) {
      this.buildValueOptions(this.expression.elementId);

      this.form.patchValue({
        elementId: this.expression.elementId,
        operator: this.expression.operator,
        value: this.expression.value
      })
    }

    this.form.valueChanges.subscribe(value => {
      this.expression.elementId = value.elementId;
      this.expression.operator = value.operator;
      this.expression.value = value.value;

      this.changed.emit(this.expression);
    });

    this.form.get('elementId').valueChanges.subscribe(value => {
      this.buildValueOptions(value);
    });
  }

  buildValueOptions(elementId: string) {
    this.valueOptions = [];
    if (!elementId || elementId === '')
      return;

    const element = this.elements.find(e => e.id.toString() === elementId);
    if (element.options && element.options.length > 0)
      this.valueOptions = element.options.map(o => ({value: o.id.toString(), text: o.text}));
  }

  removeCondition() {
    this.remove.emit();
  }
}
